//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {
  pageModule,
  categoryModule
} from "@/api/cms.js";
import {
  generatescheme
} from "@/api/index.js";
import {
  getCookie
} from "@/utils/auth.js";
import Swiper from "swiper/swiper-bundle.min.js";
import {
  List,
  PullRefresh,
  Sticky,
  Overlay,
  Loading
} from "vant";
import TabBar from "@/components/footer";
export default {
  data() {
    return {
      pageData: {},
      currentTabIndex: 0, //选中tab的index
      currentTabCid: "", //商品分类的cid
      currentTabTitle: "", //选中tab的title
      pageSize: 10, //每页数据
      offset: 1, //当前页数
      categoryList: [], //分类商品
      list: [],
      loading: false,
      finished: false,
      refreshing: false,
      headerFixed: false,
      showFloating: false,
      catEmpty: false,
      showLoading: true, //页面加载loading
      index_popup_url: "",
      new_user_page_header_url: "",
      new_user_page_popup_url: "",
      new_user_gift_url: "",
      order_unlock_popup_url: "",
      index_url: "",
      utm_source:"",//来源
    };
  },

  components: {
    List: List,
    [PullRefresh.name]: PullRefresh,
    [Sticky.name]: Sticky,
    TabBar,
    [Overlay.name]: Overlay,
    [Loading.name]: Loading,
  },

  computed: {},

  created() {
    this.id = this.getQueryString("pageId");
    this.utm_source = this.getQueryString("utm_source");
    this.getPageModule();

  },

  mounted() {
    this.swiperobj();
    // handleScroll为页面滚动的监听回调
    window.addEventListener("scroll", this.handleScroll);
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  },

  methods: {
    //获取url参数
    getQueryString: function(name) {
      var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i');
      var r = window.location.search.substr(1).match(reg);

      if (r != null) {
        return unescape(r[2]);
      }
      return null;
    },
    isFiexed(isFiexed) {
      console.log(isFiexed, "isFiexed");
      var box = document.querySelector(".goods-list");
      console.log(box, "box");
    },
    handleScroll() {
      // 得到页面滚动的距离
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      // 判断页面滚动的距离是否大于吸顶元素的位置

      this.headerFixed =
        scrollTop > this.offsetTop + this.offsetHeight * 2 + 15;
      if (scrollTop > 300) {
        this.showFloating = true;
      } else {
        this.showFloating = false;
      }
    },
    onLoad() {
      this.offset++;
      this.getCategoryModule();
    },
    onRefresh() {
      this.getCategoryModule();
    },
    getPageModule(type) {
      let str;
      //如果没有utm_source不传
      if(this.utm_source != null && this.utm_source != "" && this.utm_source != "null"){
        str = this.id + "?suffix=" + this.utm_source;
      }else{
        str = this.id
      }

      pageModule(str).then((res) => {
        let pageData = res.data;
        this.utm_source = pageData.suffix;//来源

        //记录第一次进入的来源
        let first_utm_source = localStorage.getItem("first_utm_source")
        if(first_utm_source == "" || first_utm_source == null || first_utm_source == "undefined"){
          localStorage.setItem("first_utm_source",pageData.suffix)
        }

        let informText = ""
        pageData.modulePageInfoList.map((item) => {
          item.content = JSON.parse(item.content);

          if (item.moduleType == 8) {
            item.content.pictures.map((pitem) => {
              pitem.goodsList = JSON.parse(pitem.goodsList);
            })
          }


        })

        this.pageData = pageData;
        console.log(this.pageData, "this.pageData");
        this.$nextTick(() => {
          this.swiperobj();
        });
        //loading隐藏
        this.showLoading = false
        this.$nextTick(function() {
          // 这里fixedHeaderRoot是吸顶元素的ID
          let header = document.getElementById("tabBox");
          if (header != undefined) {
            // 这里要得到top的距离和元素自身的高度
            this.offsetTop = header.offsetTop;
            this.offsetHeight = header.offsetHeight;
            console.log(
              "offsetTop:" + this.offsetTop + "," + this.offsetHeight
            );
          } else {
            window.removeEventListener("scroll", this.handleScroll);
          }

          console.log(informText, 'informText')
          if (informText != "") {
            this.informText = informText
            this.informScroll();
          }

        });

      });
    },

    //返回顶部
    goTop() {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    },
    //跳转到商品详情
    gotoProductFun: function(goodsCode) {
      window.location.href = process.env.PAGEURL + "/goodDetails?gid=" + goodsCode + "&utm_source=" + this.utm_source;
    },
    //活动点击事件
    gotoActionFun:function(redirectType,item){
      console.log("redirectType-------",redirectType);
      //自定义链接
      if(redirectType == 1){
        if(item.picRedirectUrl.indexOf('pages/activityPublic/index') >= 0){
          this.generateschemeFun(item.picRedirectUrl);
        }else{
          window.location.href = item.picRedirectUrl;
        }
      }else if(redirectType == 3){
        window.location.href = process.env.PAGEURL + "/goodDetails?gid=" + item.goodsCode + "&utm_source=" + this.utm_source;
      }
    },
    //获取小程序跳转链接
    generateschemeFun:function(url){
      let that = this;
      let params = {
      	miniAppId: "wx3b8f20b180312e78",
      	path: url
      };
      generatescheme(params).then(res=>{
        if (res.errcode == 0 && res.openlink != "") {
          console.log("res.openlink------",res.openlink)
          window.location.href = res.openlink;
        }else{

        }
      })
    },

    //swiper
    swiperobj() {
      var swiper = new Swiper(".swiper", {
        pagination: {
          el: ".swiper-pagination",
          // clickable: true,
        },
        loop: true,
        autoplay: {
          delay: 3000,
          disableOnInteraction: false,
        },
        observer: true,
        lazyLoading: true,
      });
      // return swiper;
    },




    isToday(date) {
      if (date) {
        return date.toString().slice(0, 6) === Date.parse(new Date()).toString().slice(0, 6);
      } else {
        return false;
      }

    },
    //分类商品
    getCategoryModule(type) {},
  },
};



// WEBPACK FOOTER //
// ./src/view/cmssys/cmsPage.vue